import React from 'react';
import { Text } from '@chakra-ui/react';

const SelectGroupLabel: React.FC<{ isFirstGroup?: boolean; dark: boolean }> = ({
  children,
  isFirstGroup,
  dark,
}) => (
  <Text
    mt={isFirstGroup ? 2 : 4}
    mx={2}
    px={2}
    py={1}
    borderTop={isFirstGroup ? 'none' : '1px solid'}
    borderColor={dark ? 'gray.900' : 'gray.200'}
    color={dark ? 'gray.100' : 'gray.600'}
    fontSize="sm"
    fontWeight="bold"
    textTransform="uppercase"
  >
    {children}
  </Text>
);

export default SelectGroupLabel;
